<script setup lang="ts">
const form = useForm({
	method: 'POST',
	url: route('password.email'),
	fields: {
		email: '',
	},
})

const status = useProperty('status')
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/auth.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<message-wrapper>
		<message-success v-if="status" class="mb-2">
			{{ status }}
		</message-success>
	</message-wrapper>

	<form class="space-y-5" @submit.prevent="form.submit">
		<form-input-wrapper :label="t('app.email')" for="email" :errors="form.errors.email">
			<form-input-text
				id="email"
				v-model="form.fields.email"
				type="email"
				required
				autofocus
				autocomplete="username"
			/>
		</form-input-wrapper>

		<div class="flex">
			<button-base type="submit" :loading="form.processing" class="ml-auto">
				{{ t('app.reset_password') }}
			</button-base>
		</div>
	</form>
</template>
